(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gk-sticky-atc"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.gk-sticky-atc').forEach(function (bar) {
    var atc = document.getElementById(bar.dataset.target);
    if (!atc || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('.gk-sticky-atc__btn');
    var scope = bar.closest('.shopify-section') || document;
    // Releasit renders two #rsi_buy_now_button nodes (one zero-height) and hides Dawn's
    // Add to cart, so always pick the COD button that is actually on the page.
    function cod() {
      var list = scope.querySelectorAll('#rsi_buy_now_button');
      for (var i = 0; i < list.length; i++) if (list[i].offsetHeight > 0) return list[i];
      return null;
    }
    function toggle(show) {
      bar.hidden = !show;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('gk-sticky-open', show);
    }
    // Visible whenever the in-page buy button is off screen (above or below), so a CTA
    // is on the first mobile screen too. Hidden while the real button is in view.
    var observer = new IntersectionObserver(function (entries) { toggle(!entries[0].isIntersecting); }, { threshold: 0 });
    var watched = null;
    function watch() {
      var t = cod() || (atc.offsetHeight > 0 ? atc : null);
      if (!t || t === watched) return !!t;
      if (watched) observer.unobserve(watched);
      observer.observe((watched = t));
      return true;
    }
    watch();
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if ((watch() && cod()) || tries > 20) clearInterval(poll);
      // Fall back to "Add to cart" wording if the COD app button never appears
      if (tries > 20 && !cod()) btn.textContent = btn.dataset.atcLabel;
    }, 300);
    btn.addEventListener('click', function () {
      var c = cod();
      if (c) { c.click(); return; }
      if (atc.disabled) return;
      atc.click();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
